import React, { createContext, useState, useEffect, useRef } from 'react';
import { NavigationUtils } from 'lib/navigationUtilities';

export const ReferrerContext = createContext();

export const ReferrerProvider = ({ children }) => {
  const { locationPathName } = NavigationUtils();
  const [referrer, setReferrer] = useState(null);
  const [profileNavigationHistory, setProfileNavigationHistory] = useState({});
  const previousPathRef = useRef(null);

  const isProfilePage = path => /^\/[^/]+$/.test(path) && path !== '/';
  const isEditProfilePage = path => path === '/profile/edit';

  useEffect(() => {
    if (previousPathRef.current === null) {
      previousPathRef.current = locationPathName;
      return;
    }

    const previousPath = previousPathRef.current;
    const currentPath = locationPathName;

    if (isEditProfilePage(currentPath) || isEditProfilePage(previousPath)) {
      previousPathRef.current = currentPath;
      return;
    }

    if (isProfilePage(currentPath)) {
      setProfileNavigationHistory(prev => ({
        ...prev,
        [currentPath]: previousPath
      }));
    }

    previousPathRef.current = currentPath;
  }, [locationPathName]);

  const updateReferrer = (path) => {
    if (locationPathName !== path) {
      setReferrer(path);
    }
  };

  const getProfileBackDestination = (profilePath) => {
    return profileNavigationHistory[profilePath] || '/';
  };

  return (
    <ReferrerContext.Provider value={{
      referrer,
      updateReferrer,
      profileNavigationHistory,
      getProfileBackDestination
    }}>
      {children}
    </ReferrerContext.Provider>
  );
};
